import { Message } from 'element-ui';
export default class Utils {
    // 数据排序
    static sortArray(array, key) {
        array = this.getUnique(array)
        if (!key) return array;
        let aMap = [];
        let aResult = [];

        for (let i = 0; i < array.length; i++) {
            let item = array[i];
            if (aMap.indexOf(item[key]) === -1) {
                aResult.push([item]);
                aMap.push(item[key]);
            } else {
                let index = aMap.indexOf(item[key]);
                aResult[index].push(item);
            }
        }
        return aResult;
    }
    // 数组去重
    static getUnique(arr) {
        var result = [];
        var obj = {};
        for (var i = 0; i < arr.length; i++) {
            if (!obj[arr[i].specId]) {
                result.push(arr[i]);
                obj[arr[i].specId] = true;
            }
        }
        return result
    }
    /**
    * 复制文本
    * @param {string} text 字符串
    * @returns {null}  
    */
    static async copyJSON(text) {
        let target = document.createElement("input"); //创建input节点
        target.id = "copy";
        target.value = text;
        document.body.appendChild(target);
        target.select();
        if (await document.execCommand("Copy")) {
            document.body.removeChild(document.getElementById("copy"));
            Message.success({ message: "复制成功！", duration: 1000 })
        } else {
            Message.error({ message: "复制失败！", duration: 1000 })
        }
    }
    /**
    * 获取当前时间
    * @returns {String} 时间 
    */
    static getTime() {
        let date = new Date()
        var year = date.getFullYear();
        var month =
            date.getMonth() + 1 < 10 ?
                "0" + (date.getMonth() + 1) :
                date.getMonth() + 1;
        var day =
            date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hours =
            date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes =
            date.getMinutes() < 10 ?
                "0" + date.getMinutes() :
                date.getMinutes();
        var seconds =
            date.getSeconds() < 10 ?
                "0" + date.getSeconds() :
                date.getSeconds();
        let time = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        return time
    }
    /**
       * 浏览器解析
       * @param {string} name 浏览器链接需要解析的 名称 字符串
       * @returns {String} 
       */
    static GetQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
}


// WEBPACK FOOTER //
// ./src/utils/tools.js